import React, { useEffect, useState } from 'react';
import { apiClient } from '../../../lib/api-client';
import { LoadIndicator } from 'devextreme-react/load-indicator';
import { TableauTokenData } from '../../../features/cfi/metrics/types/TableauTokenData';
import { TableauEmbed } from '@stoddabr/react-tableau-embed-live';

declare global {
    interface Window {
        tableau: any;
    }
}

interface TableauProps {
    data: {
        text: string,
        id: string,
        width: string,
        height: string,
        chartname: string
    }
}

const TableauChart = (props: TableauProps) => {
    const [tableauIsLoading, setTableauIsLoading] = useState<boolean>(true);
    const [embedUrl, setEmbedUrl] = useState<string>();
    const [embedToken, setEmbedToken] = useState<string>('-1');

    const { id, chartname } = props.data;

    useEffect(() => {
        const fetchTableauTokenData = async () => {
            try {
                const response = await apiClient.get('/metrics/get-tableau-token-data') as TableauTokenData;
                if (response) {
                    setEmbedUrl(`${response.server}/views/${chartname}`);
                    setEmbedToken(response.token);
                }
                setTableauIsLoading(false);
            } catch (error) {
                // Handle error
                console.error('Error fetching tableau token data:', error);
                setTableauIsLoading(false);
            }
        };

        fetchTableauTokenData();
    }, []);

    return (
        tableauIsLoading || !embedUrl
            ?
            <div className={'responsive-paddings'}>
                <LoadIndicator width={'24px'} height={'24px'} visible={true} />
            </div>
            :
            (embedToken == null || embedToken == '-1'
                ?
                <div className={'responsive-paddings'}>
                    <p>
                        <span>If you don't have access, please contact </span>
                        <a href={'mailto:sales@sagesurfaces.com'} >sales@sagesurfaces.com</a>
                    </p>
                </div>
                :
                    <TableauEmbed 
                        sourceUrl={embedUrl} 
                        token={embedToken}
                        hide-tabs={true}
                        hide-toolbar={false}
                        show-app-banner={false}
                        width={props.data.width}
                        height={'calc(100vh - 240px)'} />
            )
    )
};

export default TableauChart;
